export const getFinalPrice = (item = {}) => {
  const price = Math.max(Number(item?.price || 0), 0);
  const campaignSalePrice = Number(item?.campaign_sale_price || 0);

  if (campaignSalePrice > 0 && (price <= 0 || campaignSalePrice < price)) {
    return Math.round(campaignSalePrice);
  }

  const salePrice = Number(item?.sale_price || 0);

  if (salePrice > 0 && (price <= 0 || salePrice < price)) {
    return Math.round(salePrice);
  }

  const discountPercent = Math.min(
    Math.max(Number(item?.discount || item?.discount_percent || 0), 0),
    95
  );

  if (price > 0 && discountPercent > 0) {
    return Math.round(price * (1 - discountPercent / 100));
  }

  return Math.round(price);
};
